<span
  class="complex-list-item-location"
  #locationElement
  ftrTooltip
  [template]="locationName"
  [showDash]="false"
  [forceDisplayState]="isElementTruncated(locationElement) ? undefined : tooltipDisplay.Hide"
>
  @if (department) {
    <span class="light">&nbsp;in </span><strong>{{ department!.name }}</strong>
  }
  @if (location) {
    <span class="light">&nbsp;at </span>
    <span>
      <ng-container *ngTemplateOutlet="locationName"></ng-container>
    </span>
  }
</span>

<ng-template #locationName>
  <strong>{{ location?.parent?.name }}</strong> - {{ location?.name }}
</ng-template>
